import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./report_schedule_scope.js";
//#region src/report_schedule_scope_helper.ts
var report_schedule_scope_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(reportType) {
	switch (reportType) {
		case "daily": return "Daily";
		case "weekly": return "Weekly";
		case "monthly": return "Monthly";
	}
}
//#endregion
export { name, report_schedule_scope_helper_exports };

//# sourceMappingURL=report_schedule_scope_helper.js.map